import * as React from 'react';

const QuestionCircle24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12 21.5a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12 7.75c-.826 0-1.5.674-1.5 1.5a.75.75 0 0 1-1.5 0c0-1.654 1.346-3 3-3s3 1.346 3 3c0 1.133-.538 2.036-1.415 2.716-.362.28-.835.515-.835 1.034a.75.75 0 0 1-1.5 0c0-1.031.662-1.635 1.415-2.219.514-.399.835-.86.835-1.531 0-.826-.674-1.5-1.5-1.5M13 16a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
  }
));
QuestionCircle24.Size = 24;
QuestionCircle24.Title = "QuestionCircle";

export { QuestionCircle24 as default };
